import React from "react";
import { MessageHelpPanel } from "../../CreateTemplateModal/components/ProjectTemplateCreateSelectTypeModal.styles";
import { useTranslations } from "../../utils";
import {
  MessageHelpLinkStyled,
  OpenIconLink,
} from "./FromProjectDetails.styles";
var CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE =
  "https://help.autodesk.com/view/BUILD/ENU/?guid=Templates_Included";
export var FromProjectDetails = function () {
  var T = useTranslations().T;
  return React.createElement(
    "span",
    null,
    T.translate("createTemplateModal.fromProjectDetails", {
      LinkToHelpArticle: React.createElement(
        MessageHelpPanel,
        null,
        React.createElement(
          MessageHelpLinkStyled,
          {
            href: CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE,
            target: "_blank",
            rel: "noopener noreferrer",
          },
          T.translate("createTemplateModal.fromProjectLinkText"),
          React.createElement(OpenIconLink, { size: 15 })
        )
      ),
    })
  );
};
